import React from 'react';
import PropTypes from 'prop-types';
import Forms from '@components/forms/component';

import styles from './styles.module.scss';
const { header, step_two, center_form, details_text } = styles;

const StepTwo = (props) => {
  let {
    agentId,
    nextStepCallback,
    setModalIsOpen,
    userInfo,
    address,
    time,
    date,
    availability,
    details,
    fullName,
    fullNameCallback,
    phoneRequired,
    email,
    phoneNumber,
    agent,
    associatedAgentId,
    listingId,
    loggedInUserId,
    agentCallback,
    phoneNumberCallback,
    emailCallback,
    selected
  } = props;

  // -------------------------------------------------------

  // -------------------------------------------------------

  return (
    <>
      <div className={step_two}>
        <div className={header}>
          <h2>Contact Information</h2>
          <p>{`You're requesting a showing of ${address},`}</p>
          {(availability === 'This Weekend' ||
            availability === 'Next Weekend' ||
            availability === 'Next Available') && (
            <>
              <p>{availability}</p>
              {details && <p className={details_text}>"{details}"</p>}
            </>
          )}
          {availability === 'Specific Date/Time' && (
            <p>
              on {date?.getMonth() + '/' + date?.getDate() + '/' + date?.getFullYear()} at {time}.
            </p>
          )}
        </div>
        <div className={center_form}>
          <Forms
            theme="no-background"
            userInfo={userInfo}
            emailRequired={true}
            phoneNumberRequired={phoneRequired}
            workingWithAgentField={true}
            linkLabel="Submit Tour Request"
            endpoint="request a tour"
            setModalIsOpen={setModalIsOpen}
            nextStepCallback={nextStepCallback}
            fullNameRequestModal={fullName}
            fullNameRequestModalCallback={fullNameCallback}
            agent={agent}
            endpointId={listingId}
            loggedInUserId={loggedInUserId}
            associatedAgentId={associatedAgentId}
            agentCallback={agentCallback}
            email={email}
            emailCallback={emailCallback}
            phoneNumber={phoneNumber}
            phoneNumberCallback={phoneNumberCallback}
            date={date}
            details={details}
            availability={availability}
            time={time}
            selected={selected}
            agentId={agentId}
          />
        </div>
      </div>
    </>
  );
};

StepTwo.propTypes = {
  /**
   * Specifies the listing address
   */
  address: PropTypes.string,

  /**
   * Specifies the user's assosciated agent
   */
  agent: PropTypes.string,

  /**
   * Function that sets the user's assosciated agent
   */
  agentCallback: PropTypes.func,

  /**
   * Specifies the id of the LDP agent card
   */
  agentId: PropTypes.number,

  /**
   * Specifies the LoggedIn user's associatedAgentId
   */
  associatedAgentId: PropTypes.string,

  /**
   * Specifies the user's availability to see the listing
   */
  availability: PropTypes.object,

  /**
   * Specifies what step the modal is on
   */
  currentStep: PropTypes.string,

  /**
   * Specifies the date the user wishes to view the listing
   */
  date: PropTypes.string,

  /**
   * Specifies any details a user may have about their availability
   */
  details: PropTypes.string,

  /**
   * Specifies the user's email
   */
  email: PropTypes.string,

  /**
   * Function that sets the user's email
   */
  emailCallback: PropTypes.func,

  /**
   * Specifies if the user's email is a required input field
   */
  emailRequired: PropTypes.bool,

  /**
   * Specifies the user's fullname
   */
  fullName: PropTypes.string,

  /**
   * Function that sets the user's full name
   */
  fullNameCallback: PropTypes.func,

  /**
   * Specifies the current listing ID
   */
  listingId: PropTypes.string,

  /**
   * Specifies the logged in user's Id
   */
  loggedInUserId: PropTypes.string,

  /**
   * Callback func that tracks the next step click
   */
  nextStepCallback: PropTypes.func,

  /**
   * Specifies the user's phone number
   */
  phoneNumber: PropTypes.string,

  /**
   * Function that sets the user's phone number
   */
  phoneNumberCallback: PropTypes.func,

  /**
   * Specifies if the user's phone is a required input field
   */
  phoneRequired: PropTypes.bool,

  /**
   * Specifies the selected array
   */
  selected: PropTypes.array,

  /**
   * Function that opens or closes the request a tour modal
   */
  setModalIsOpen: PropTypes.func,

  /**
   * Specifies what time the user wishes to view the listing
   */
  time: PropTypes.string,

  /**
   * Specifies the logged in user's information
   */
  userInfo: PropTypes.object
};

export default StepTwo;
